<div class="vex-mail-content-header flex-none flex items-center px-6 border-b">
  <mat-checkbox
    (change)="masterToggle(mails, $event)"
    *ngIf="mails$ | async as mails"
    [checked]="isAllSelected(mails)"
    [indeterminate]="isSomeButNotAllSelected(mails)"
    color="primary"></mat-checkbox>

  <div *ngIf="selection.hasValue()" class="ml-5 pl-3 border-l">
    <button
      (click)="markSelected(true)"
      color="primary"
      mat-icon-button
      matTooltip="Mark as read"
      matTooltipPosition="below"
      type="button">
      <mat-icon svgIcon="mat:check"></mat-icon>
    </button>

    <button
      (click)="markSelected(false)"
      class="ml-1"
      color="primary"
      mat-icon-button
      matTooltip="Mark as unread"
      matTooltipPosition="below"
      type="button">
      <mat-icon svgIcon="mat:mark_email_unread"></mat-icon>
    </button>

    <button
      [matMenuTriggerFor]="moveMenu"
      class="ml-1"
      color="primary"
      mat-icon-button
      matTooltip="Move to"
      matTooltipPosition="below"
      type="button">
      <mat-icon svgIcon="mat:folder"></mat-icon>
    </button>

    <button
      (click)="openLabelDialog()"
      class="ml-1"
      color="primary"
      mat-icon-button
      matTooltip="Add Label"
      matTooltipPosition="below"
      type="button">
      <mat-icon svgIcon="mat:label"></mat-icon>
    </button>

    <button
      (click)="confirmDelete()"
      class="ml-1"
      color="warn"
      mat-icon-button
      matTooltip="Delete selected"
      matTooltipPosition="below"
      type="button">
      <mat-icon svgIcon="mat:delete"></mat-icon>
    </button>
  </div>

  <span class="flex-1"></span>

  <div class="mail-toolbar-group mr-3">
    <button
      (click)="setReadFilter('all')"
      [class.mail-toolbar-button--active]="(readFilter$ | async) === 'all'"
      class="mail-toolbar-button"
      type="button">
      All
    </button>
    <button
      (click)="setReadFilter('unread')"
      [class.mail-toolbar-button--active]="(readFilter$ | async) === 'unread'"
      class="mail-toolbar-button"
      type="button">
      Unread
    </button>
    <button
      (click)="setReadFilter('read')"
      [class.mail-toolbar-button--active]="(readFilter$ | async) === 'read'"
      class="mail-toolbar-button"
      type="button">
      Read
    </button>
  </div>

  <div class="mail-toolbar-group mr-3" *ngIf="gtSm$ | async">
    <button
      (click)="setViewMode('split')"
      [class.mail-toolbar-button--active]="!isDraftFolder() && (viewMode$ | async) === 'split'"
      [disabled]="isDraftFolder()"
      class="mail-toolbar-button"
      type="button">
      Split
    </button>
    <button
      (click)="setViewMode('focus')"
      [class.mail-toolbar-button--active]="isDraftFolder() || (viewMode$ | async) === 'focus'"
      class="mail-toolbar-button"
      type="button">
      Open
    </button>
  </div>

  <button
    (click)="refresh()"
    color="primary"
    mat-icon-button
    matTooltip="Refresh"
    matTooltipPosition="below"
    type="button">
    <mat-icon svgIcon="mat:refresh"></mat-icon>
  </button>
</div>

<mat-menu #moveMenu="matMenu">
  <button (click)="moveSelected('INBOX')" mat-menu-item>
    <span>Inbox</span>
  </button>
  <button (click)="moveSelected('SENT')" mat-menu-item>
    <span>Sent</span>
  </button>
  <button (click)="moveSelected('DRAFT')" mat-menu-item>
    <span>Draft</span>
  </button>
  <button (click)="moveSelected('TRASH')" mat-menu-item>
    <span>Trash</span>
  </button>
</mat-menu>

<div class="flex-auto overflow-hidden">
  <ng-container *ngIf="(gtSm$ | async) && !isDraftFolder() && (viewMode$ | async) === 'split'; else focusLayout">
    <div class="grid h-full grid-cols-1 sm:grid-cols-2 overflow-hidden">
      <div class="mail-list-panel flex flex-col overflow-hidden">
        <vex-scrollbar @stagger class="flex-1 py-3">
          <vex-mail-list-entry
            (selectedChange)="
              $event ? selection.select(mail.id) : selection.deselect(mail.id)
            "
            *ngFor="let mail of mails$ | async; trackBy: trackById"
            @fadeInUp
            [mail]="mail"
            [selected]="selection.isSelected(mail.id)"
            class="block"></vex-mail-list-entry>
        </vex-scrollbar>

        <div class="mail-pagination border-t px-4 py-3">
          <button (click)="prevPage()" [disabled]="mailService.currentPage.value <= 1" mat-stroked-button type="button">Prev</button>
          <span>Page {{ mailService.currentPage.value }} / {{ mailService.totalPages }}</span>
          <button (click)="nextPage()" [disabled]="mailService.currentPage.value >= mailService.totalPages" mat-stroked-button type="button">Next</button>
        </div>
      </div>

      <div class="mail-preview-pane flex flex-col ltr:border-l rtl:border-r">
         <vex-mail-view></vex-mail-view>
      </div>
    </div>
  </ng-container>

  <ng-template #focusLayout>
    <div *ngIf="selectedMail$ | async as selectedMail; else mailListOnly" class="mail-preview-pane mail-focus-layout flex h-full flex-col">
      <div class="mail-focus-header flex items-center gap-2 border-b px-4 py-3">
        <button (click)="backToList()" mat-icon-button type="button">
          <mat-icon svgIcon="mat:arrow_back"></mat-icon>
        </button>
        <p class="mail-focus-title flex-1 truncate">{{ selectedMail.subject }}</p>
      </div>
      <vex-mail-view></vex-mail-view>
    </div>

    <ng-template #mailListOnly>
      <div class="mail-list-only-shell h-full overflow-hidden">
        <vex-scrollbar @stagger class="mail-list-only-scroll flex-1 py-3">
          <vex-mail-list-entry
            (selectedChange)="
              $event ? selection.select(mail.id) : selection.deselect(mail.id)
            "
            *ngFor="let mail of mails$ | async; trackBy: trackById"
            @fadeInUp
            [mail]="mail"
            [selected]="selection.isSelected(mail.id)"
            class="block"></vex-mail-list-entry>
        </vex-scrollbar>
        <div class="mail-pagination border-t px-4 py-3">
          <button (click)="prevPage()" [disabled]="mailService.currentPage.value <= 1" mat-stroked-button type="button">Prev</button>
          <span>Page {{ mailService.currentPage.value }} / {{ mailService.totalPages }}</span>
          <button (click)="nextPage()" [disabled]="mailService.currentPage.value >= mailService.totalPages" mat-stroked-button type="button">Next</button>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
